/* eslint-disable */
export const generatedEnvironment = {
    "release": "c25aaf6317"
};
